function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import LocaleKeys from '../../../../locales/keys';
import BWConstants from './blocklist.allowlist.constants';
import { i18n, LogHelper } from 'invision-core';
import { pathOr } from 'ramda';
import { SelectedReasonIdSelector } from '../../../../reducers/selectors/blocklist.allowlist.selectors';
import { addPaymentInstrumentToBlocklist, addPaymentInstrumentToAllowlist, removePaymentInstrumentFromBlocklist, removePaymentInstrumentFromAllowlist, setSelectedReasonId } from '../../../../reducers/actions/blocklist.allowlist.actions';
import { CurrentCustomerIdSelector } from '../../../../reducers/selectors/customer.selectors';
import { SelectedPaymentModelBasedOnRecoverableUI } from '../../../../reducers/selectors/customer.ewallet.selectors';
import { NOTIFICATION_TIME_LENGTH } from '../../../../customercare.constants';
var mapStateToTarget = function mapStateToTarget(store) {
  return {
    currentCustomerId: CurrentCustomerIdSelector(store),
    selectedPaymentMethod: SelectedPaymentModelBasedOnRecoverableUI(store),
    selectedReasonId: SelectedReasonIdSelector(store)
  };
};
var AVAILABLE_METADATA = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, BWConstants.STATE_ADD_TO_BLOCKLIST, {
  metaDataKey: 'BlocklistAddReason'
}), BWConstants.STATE_ADD_TO_ALLOWLIST, {
  metaDataKey: 'AllowlistAddReason'
}), BWConstants.STATE_REMOVE_FROM_BLOCKLIST, {
  metaDataKey: 'BlocklistRemoveReason'
}), BWConstants.STATE_REMOVE_FROM_ALLOWLIST, {
  metaDataKey: 'AllowlistRemoveReason'
});
var AVAILABLE_CONTROLLER_ACTIONS = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, BWConstants.STATE_ADD_TO_BLOCKLIST, {
  serviceCall: addPaymentInstrumentToBlocklist,
  setSelectedReasonId: setSelectedReasonId
}), BWConstants.STATE_ADD_TO_ALLOWLIST, {
  serviceCall: addPaymentInstrumentToAllowlist,
  setSelectedReasonId: setSelectedReasonId
}), BWConstants.STATE_REMOVE_FROM_BLOCKLIST, {
  serviceCall: removePaymentInstrumentFromBlocklist,
  setSelectedReasonId: setSelectedReasonId
}), BWConstants.STATE_REMOVE_FROM_ALLOWLIST, {
  serviceCall: removePaymentInstrumentFromAllowlist,
  setSelectedReasonId: setSelectedReasonId
});
var BlockAllowModalComponentController = /*#__PURE__*/function () {
  function BlockAllowModalComponentController($ngRedux, $timeout, uiNotificationService) {
    _classCallCheck(this, BlockAllowModalComponentController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $timeout: $timeout,
      uiNotificationService: uiNotificationService
    });
    this.localeKeys = LocaleKeys;
    this.commentText = '';
    this.MODAL_TEXT_ENTRIES = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, BWConstants.STATE_ADD_TO_BLOCKLIST, {
      title: i18n.translate(LocaleKeys.E_WALLET.MODALS.ADD_TO_BLOCKLIST_MENU_TEXT),
      successMessage: i18n.translate(this.localeKeys.E_WALLET.MODALS.ADD_TO_BLOCKLIST_SUCCESS_MESSAGE)
    }), BWConstants.STATE_ADD_TO_ALLOWLIST, {
      title: i18n.translate(LocaleKeys.E_WALLET.MODALS.ADD_TO_ALLOWLIST_MENU_TEXT),
      successMessage: i18n.translate(this.localeKeys.E_WALLET.MODALS.ADD_TO_ALLOWLIST_SUCCESS_MESSAGE)
    }), BWConstants.STATE_REMOVE_FROM_BLOCKLIST, {
      title: i18n.translate(LocaleKeys.E_WALLET.MODALS.REMOVE_FROM_BLOCKLIST_MENU_TEXT),
      successMessage: i18n.translate(this.localeKeys.E_WALLET.MODALS.REMOVE_FROM_BLOCKLIST_SUCCESS_MESSAGE)
    }), BWConstants.STATE_REMOVE_FROM_ALLOWLIST, {
      title: i18n.translate(LocaleKeys.E_WALLET.MODALS.REMOVE_FROM_ALLOWLIST_MENU_TEXT),
      successMessage: i18n.translate(this.localeKeys.E_WALLET.MODALS.REMOVE_FROM_ALLOWLIST_SUCCESS_MESSAGE)
    });
    this.errorsObject = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, BWConstants.STATE_ADD_TO_BLOCKLIST, LocaleKeys.E_WALLET.MODALS.ERRORS.BLOCKLIST_ADD_REASON_REQUIRED), BWConstants.STATE_ADD_TO_ALLOWLIST, LocaleKeys.E_WALLET.MODALS.ERRORS.ALLOWLIST_ADD_REASON_REQUIRED), BWConstants.STATE_REMOVE_FROM_BLOCKLIST, LocaleKeys.E_WALLET.MODALS.ERRORS.BLOCKLIST_REMOVE_REASON_REQUIRED), BWConstants.STATE_REMOVE_FROM_ALLOWLIST, LocaleKeys.E_WALLET.MODALS.ERRORS.ALLOWLIST_REMOVE_REASON_REQUIRED);
    this.onReasonSelected = this.onReasonSelected.bind(this);
    this.onSubmitForm = this.onSubmitForm.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.resetForm = this.resetForm.bind(this);
  }
  return _createClass(BlockAllowModalComponentController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var controllerActions = AVAILABLE_CONTROLLER_ACTIONS[this.modalState];
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.metaDataKey = AVAILABLE_METADATA[this.modalState].metaDataKey;
      this.formFieldLocaleKeyMapping = {
        reason: this.errorsObject[this.modalState]
      };
      this.resetForm();
    }
  }, {
    key: "onSubmitForm",
    value: function onSubmitForm() {
      var _this2 = this;
      if (this.bwForm.$invalid) {
        return;
      }
      if (this.awaitingAsyncOperation) {
        LogHelper.warn('blocklist/allowlist request submitted while awaiting pre-existing async op');
        return;
      }
      if (this.state.selectedReasonId) {
        var paymentMethodUpdated = false;
        var custId = this.state.currentCustomerId;
        var paymentMethodId = this.state.selectedPaymentMethod.Id;
        var reasonId = parseInt(this.state.selectedReasonId, 10);
        this.actions.serviceCall(custId, paymentMethodId, reasonId, this.commentText).then(function () {
          paymentMethodUpdated = true;
          _this2.actions.setSelectedReasonId(null);
          _this2.uiNotificationService.success(i18n.translate(_this2.MODAL_TEXT_ENTRIES[_this2.modalState].successMessage), null, {
            timeOut: NOTIFICATION_TIME_LENGTH
          });
          _this2.handleClose(paymentMethodUpdated);
        }).catch(function (error) {
          _this2.handleClose(paymentMethodUpdated, error);
        });
      }
    }
  }, {
    key: "handleClose",
    value: function handleClose(paymentMethodUpdated, error) {
      // Call the onClose callback passed to the component
      this.onClose()(paymentMethodUpdated, error);
    }
  }, {
    key: "onReasonSelected",
    value: function onReasonSelected(selectedReason) {
      this.actions.setSelectedReasonId(selectedReason && selectedReason.id);
    }
  }, {
    key: "resetForm",
    value: function resetForm() {
      this.actions.setSelectedReasonId(null);
    }
  }, {
    key: "$onChanges",
    value: function $onChanges() {}

    // Uses recoverableUI area of Redux to persist changes made to the mutable form model
  }, {
    key: "onChangeForm",
    value: function onChangeForm() {
      // this.actions.editEntityChanged(entity);
    }
  }, {
    key: "getTitle",
    value: function getTitle() {
      return pathOr('', ['title'], this.MODAL_TEXT_ENTRIES[this.modalState]);
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      // Clear out the recoverableUI area of Redux
      // this.actions.clearEditEntity();
      this.disconnectRedux();
    }
  }]);
}();
export default {
  template: require('./blocklist.allowlist.modal.html'),
  controller: BlockAllowModalComponentController,
  bindings: {
    config: '<',
    onClose: '&',
    onSuccess: '&',
    entity: '<',
    modalState: '<'
  }
};